import { Tooltip } from "@mui/material";
import { toolTipData } from '../../../../../main/webapp/WEB-INF/data/rebate-result-tooltip.json';
import { IncentiveHubTooltip, ToolTipWidgetProps } from "../../types";
import HelpIcon from '@mui/icons-material/Help';

export const ToolTipWidget = ({incentiveType, padding_Top, children}: ToolTipWidgetProps) => {

    const getToolTip = (incentiveType : string, tooltip: IncentiveHubTooltip[]) => {
        const toolTip = tooltip.filter((toolTip) => toolTip.incentiveType === incentiveType);
        if(toolTip.length > 0) {
            return toolTip[0].incentiveToolTip;
        }
        else {
            return "Tooltip not found";
        }
    }
    const toolTips = toolTipData as IncentiveHubTooltip[];
    const toolTipText = getToolTip(incentiveType, toolTips);
    
    return ( 
        <span >
            <Tooltip enterTouchDelay={50} title={
                <div style={{ fontSize: '14px' }}  >
                    <strong>{toolTipText !== null ? toolTipText : null}</strong>
                </div>
            } arrow sx={{ paddingLeft: '5px', paddingTop: padding_Top }}>
                {children ?? <HelpIcon />}
            </Tooltip>
        </span>
    )
}
